import { render, staticRenderFns } from "./SubSection.vue?vue&type=template&id=734fb114&scoped=true"
import script from "./SubSection.vue?vue&type=script&lang=js"
export * from "./SubSection.vue?vue&type=script&lang=js"
import style0 from "./SubSection.vue?vue&type=style&index=0&id=734fb114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734fb114",
  null
  
)

export default component.exports